import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Group summary='Properties' open mdxType="Group">
	<Item title='disabled' subtitle='boolean' mdxType="Item">
		Choose whether to allow Universal Checkout to show error messages.
	</Item>
    </Group>
    <Group summary='Callbacks' open mdxType="Group">
	<Item title='onErrorMessageShow' subtitle='(message: string) => void' mdxType="Item">
		A callback for when the error message should be displayed, you can choose to use the provided message for your own
		purposes.
	</Item>
	<Item title='onErrorMessageHide' subtitle='() => void' mdxType="Item">
		A callback for when the error message should be hidden, update own UI accordingly.
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      